/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import layoutState from "./modules/layout/reducers/index";
import commonState from "./common/reducers/index";

const intialState = {};
const middleWare = [thunk];
export const store = configureStore({
  reducer: {
    layoutState,
    commonState,
  },
});
export default store;
